<template>
  <Client />
</template>

<script lang="ts">
  import { defineComponent } from 'vue';
  import Client from '@/app/features/admin/clients/Client.vue';

  export default defineComponent({
    name: 'ClientPage',
    components: {
      Client,
    },
  });
</script>
